export default {
    id: 5,
    // Contact fields and the Job's own Questions only
    getFormTypeInputFields: () => [],
}
